import { lazy } from 'react';

import CookieConsentServiceInstance from './CookieConsentService';

import { CookieCategory } from '@shared-types/optanon.types';
import GtmHelper from '@tracking/gtm-helper';
import { language } from '@utilities/browser';
import { Trace } from '@utilities/logging';
import { getParameterByName, setParametersInUrl, setParametersInParameter } from '@utilities/url';
import { competitionTracking, videoAdvTag, videoAdsContext, jwplayerScript } from '@utilities/WindowContext';

export const trackedVideoKinds = [
  'video',
  'draw live',
  'draw vod',
  'highlights',
  'medium highlights',
  'long highlights',
  'classics',
  'editors pick',
  'goal of the week',
  'player of the week',
  'skills',
  'stars of competition',
  'uefatv',
] as const;

export const prerollClassification = {
  kind: 'Video',
  section: 'Editorial',
  contentScoring: 'S&E',
  fallback: 'unknown',
} as const;

export const JwPlayerCookieCategory = CookieCategory.ESSENTIAL;

const CookiePlaceholder = lazy(() => import(/* webpackPrefetch: true */ '@shared/CookiePlaceholder'));

export const loadJwPlayer = (container?: HTMLElement) => {
  return CookieConsentServiceInstance.appendCookieScript<JWPlayerStatic>(
    jwplayerScript,
    JwPlayerCookieCategory,
    'jwplayer',
    { containers: [container], Placeholder: CookiePlaceholder },
  );
};

export function getVideoPreoll(section: string, kind: string, contentScoring: string) {
  if (kind === prerollClassification.kind) {
    if (section === prerollClassification.section) {
      return contentScoring ?? prerollClassification.fallback;
    } else if (contentScoring === prerollClassification.contentScoring) {
      return section ?? prerollClassification.fallback;
    }
  } else {
    return kind ?? prerollClassification.fallback;
  }
  return prerollClassification.fallback;
}

export const getAdvertising = (
  subType?: string,
  section?: string,
  kind?: string,
  context?: string,
  sponsor?: string,
  lang = language,
  contentScoring?: string,
): jwplayer.AdvertisingConfig => {
  let tag = videoAdvTag;

  if (!tag) return null;

  const defParams = getParameterByName('cust_params', tag);
  const qParams = {
    competitionCode: competitionTracking?.toUpperCase() || '',
    context: context || videoAdsContext || 'Competition',
    language: lang,
    section: section || '',
    sect: GtmHelper.getFromDataLayer('pageSubType') || '',
    kind: kind || '',
    sponsor: sponsor || '',
    vid_type: subType || '',
    video_preroll: getVideoPreoll(section, kind, contentScoring),
  };
  const cust_params = setParametersInParameter(qParams, defParams);
  tag = setParametersInUrl({ cust_params }, tag).toString();

  Trace(`Preroll tag: ${tag}`);

  return {
    client: 'vast',
    schedule: [
      {
        offset: 'pre',
        tag,
        pod: null,
      },
    ],
  };
};
